export const MODE_ICON = 'icon' as const;
export const MODE_SMALL = 'small' as const;
export const MODE_BIG = 'big' as const;

export type DevToolbarMode = typeof MODE_ICON | typeof MODE_SMALL | typeof MODE_BIG;
